<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';

export default {
    init: (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');

        payload.getTruckers();
    },
    methods:{
        getTruckers: function(){
            Request.do(this, 'POST', Request.getDefaultHeader(this), {type: "USER-CUSTOMER", status:"ACTIVE"}, `${Endpoints.systemUsers.ListUserByType}`,
            (response)=>{//SUCCESS CALLBACK
                this.truckers = response.results;
            },
            (error)=>{//ERROR CALLBACK
                console.log(error);
            });
        },
        selectItem: function(item){
            if(item && item._id){
                $('#spinner').modal('toggle');
                this.nameCsv = item.firstName + item.lastName + '-indicacoes.csv';
                this.nameCsv = this.nameCsv.toLowerCase().replace(' ','').replace(' ','');
                Request.do(this, 'POST', Request.getDefaultHeader(this), {owner: item._id }, `${Endpoints.systemUsers.indicationUse}`,
                (response)=>{//SUCCESS CALLBACK
                    this.items = response.results;
                    $('#spinner').modal('toggle');  
                },
                (error)=>{//ERROR CALLBACK
                    console.log(error);
                });
                this.json_data = this.items;
            }
        }, 
        fetchData(){
            this.json_data = this.items;
            return this.json_data;
        },
        customLabelTrucker(option) {
            return `${option.firstName + ' ' + option.lastName + ' - Telefone: ' + option.primaryPhone}`
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
